import { useQuery } from '@apollo/client';
import {
  AdminBookingsTableDocument,
  BookingsQueryFilterDateType,
} from '@website/types/graphqlOperations';
import { useCallback } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import {
  BookingsTable,
  bookingTableCSV,
} from './AdminBookings/AdminBookingsTable';

export default function PeopleDepartingBookings() {
  const { loading, data } = useQuery(AdminBookingsTableDocument, {
    variables: {
      limit: 750,
      dateType: BookingsQueryFilterDateType.DEPARTURE,
    },
    fetchPolicy: 'network-only',
    pollInterval: 1000 * 5, // Poll every 5 seconds
  });

  const downloadCsv = useCallback(() => {
    if (!data?.bookings.items) {
      return;
    }
    const csv = bookingTableCSV(data.bookings.items);
    const blob = new Blob([csv], { type: 'text/csv' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a', {
      is: 'a',
    });
    a.href = url;
    a.download = 'bookings.csv';
    a.click();
  }, [data?.bookings.items]);

  return (
    <Row>
      <Col xs={12} className="py-2" onClick={downloadCsv}>
        <Button>Download CSV</Button>
      </Col>
      <Col xs={12}>
        <BookingsTable
          bookings={data ? data.bookings.items : undefined}
          loading={loading}
        />
      </Col>
    </Row>
  );
}
